import axios from "axios";
import queryString from "query-string";
import {baseUrlGateWay, middlewareRequest, middlewareResponse, middlewareResponseError,} from "./config";

const UAA_BASE_URL = `${baseUrlGateWay}/services/uaa`;

const requestAaa = axios.create({
  baseURL: UAA_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) =>
      queryString.stringify(params, { arrayFormat: "comma" }),
  },
});

requestAaa.interceptors.request.use(middlewareRequest, (error) =>
  Promise.reject(error)
);

requestAaa.interceptors.response.use(
  middlewareResponse,
  middlewareResponseError
);

const uaaApi = (options) => {
  return requestAaa({
    ...options,
    headers: { "Accept-Language": "vi", ...options.headers },
  });
};

export default uaaApi;
